import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { name: "Services", hash: "#services", id: "services" },
  { name: "How It Works", hash: "#how-it-works", id: "how-it-works" },
  { name: "Customer Journey", hash: "#journey", id: "journey" },
  { name: "Case Study", hash: "#case-study", id: "case-study" },
  { name: "Pricing", hash: "#pricing", id: "pricing" },
  { name: "About", hash: "#about", id: "about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const prefix = location.pathname === "/" ? "" : "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-500 ${
        scrolled || open ? "bg-navy-950/90 backdrop-blur-xl border-sky-500/10" : "bg-navy-950/40 backdrop-blur-md border-transparent"
      }`}
    >
      <div className="section-shell flex items-center justify-between h-[72px]">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`${prefix}${l.hash}`}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-semibold text-slate-300 hover:text-sky-400 transition-colors duration-300"
            >
              {l.name}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={`${prefix}#contact`} data-testid="nav-cta-button" className="btn-primary hidden sm:inline-flex !px-6 !py-2.5">
            Get Free Consultation <ArrowRight size={15} strokeWidth={2.5} />
          </a>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full border border-sky-500/25 text-sky-300"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="lg:hidden border-t border-sky-500/10 bg-navy-950/95 backdrop-blur-xl" aria-label="Mobile">
          <div className="section-shell py-6 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={`${prefix}${l.hash}`}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-semibold text-slate-200 hover:text-sky-400 border-b border-sky-500/5 transition-colors"
              >
                {l.name}
              </a>
            ))}
            <a href={`${prefix}#contact`} data-testid="nav-mobile-cta" onClick={() => setOpen(false)} className="btn-primary mt-5 w-full">
              Get Free Consultation <ArrowRight size={15} strokeWidth={2.5} />
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
